export enum FieldTypeEnum {
  Money = 'MONEY',
  Boolean = 'BOOLEAN',
  String = 'STRING',
  Number = 'NUMBER',
  Date = 'DATE',
  CalculationDate = 'CALCULATION_DATE',
}
